import {
  LOAD_TIME_SLOT_LIST,
  LOAD_TIME_SLOT_LIST_SUCCESS,
  LOAD_TIME_SLOT_LIST_ERROR,
  HOLD_BOOKING_SLOT,
  HOLD_BOOKING_SLOT_SUCCESS,
  HOLD_BOOKING_SLOT_ERROR,
  RELEASE_BOOKING_SLOT,
  RELEASE_BOOKING_SLOT_SUCCESS,
  RELEASE_BOOKING_SLOT_ERROR,
  BOOK_APPOINTMENT,
  BOOK_APPOINTMENT_SUCCESS,
  BOOK_APPOINTMENT_ERROR,
  SAVE_SELECTED_BOOKING_SLOT,
  SAVE_SELECTED_BOOKING_SLOT_SUCCESS,
  SAVE_SELECTED_BOOKING_SLOT_ERROR,
  CLEAR_SELECTED_BOOKING_SLOT,
  CLEAR_SELECTED_BOOKING_SLOT_SUCCESS,
  CLEAR_SELECTED_BOOKING_SLOT_ERROR,
  LOAD_BOOKING_DETAIL,
  LOAD_BOOKING_DETAIL_SUCCESS,
  LOAD_BOOKING_DETAIL_ERROR,
  RESET_BOOKING_DETAIL,
  UPDATE_BOOKING_INFO,
  UPDATE_BOOKING_INFO_SUCCESS,
  UPDATE_BOOKING_INFO_ERROR,
  RESET_TIME_SLOT_DATA,
  RESET_CURRENT_HOLDING_SLOT,
} from '../type';
import update from 'immutability-helper';

import { handleActions } from 'redux-actions';

import { initialState } from './initialize-state';

const newBookingReducer = handleActions(
  new Map([
    [
      LOAD_TIME_SLOT_LIST,
      state => {
        return update(state, {
          loadingStatus: {
            timeSlotLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_TIME_SLOT_LIST_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            timeSlotLoading: { $set: false },
          },
          timeSlotData: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      LOAD_TIME_SLOT_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            timeSlotLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
    //Load patient detail
    [
      HOLD_BOOKING_SLOT,
      state => {
        return update(state, {
          loadingStatus: {
            timeSlotLoading: { $set: true },
          },
        });
      },
    ],
    [
      HOLD_BOOKING_SLOT_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            timeSlotLoading: { $set: false },
          },
          currentHoldingSlot: { $set: action.payload },
        });
      },
    ],
    [
      HOLD_BOOKING_SLOT_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            timeSlotLoading: { $set: false },
          },
        });
      },
    ],

    //Create patient
    [
      RELEASE_BOOKING_SLOT,
      state => {
        return update(state, {
          loadingStatus: {
            releaseBookingSlotLoading: { $set: true },
          },
        });
      },
    ],
    [
      RELEASE_BOOKING_SLOT_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            releaseBookingSlotLoading: { $set: false },
          },
        });
      },
    ],
    [
      RELEASE_BOOKING_SLOT_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            releaseBookingSlotLoading: { $set: false },
          },
        });
      },
    ],

    [
      BOOK_APPOINTMENT,
      state => {
        return update(state, {
          loadingStatus: {
            bookAppointmentLoading: { $set: true },
          },
        });
      },
    ],
    [
      BOOK_APPOINTMENT_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            bookAppointmentLoading: { $set: false },
          },
        });
      },
    ],
    [
      BOOK_APPOINTMENT_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            bookAppointmentLoading: { $set: false },
          },
        });
      },
    ],
    [
      BOOK_APPOINTMENT,
      state => {
        return update(state, {
          loadingStatus: {
            bookAppointmentLoading: { $set: true },
          },
        });
      },
    ],
    [
      BOOK_APPOINTMENT_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            bookAppointmentLoading: { $set: false },
          },
        });
      },
    ],
    [
      BOOK_APPOINTMENT_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            bookAppointmentLoading: { $set: false },
          },
        });
      },
    ],

    [
      SAVE_SELECTED_BOOKING_SLOT,
      state => {
        return update(state, {
          loadingStatus: {
            saveSelectedBookingSlotLoading: { $set: true },
          },
        });
      },
    ],
    [
      SAVE_SELECTED_BOOKING_SLOT_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            saveSelectedBookingSlotLoading: { $set: false },
          },
          selectedBookingSlot: { $set: action.payload },
        });
      },
    ],
    [
      SAVE_SELECTED_BOOKING_SLOT_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            saveSelectedBookingSlotLoading: { $set: false },
          },
        });
      },
    ],

    [
      CLEAR_SELECTED_BOOKING_SLOT,
      state => {
        return update(state, {
          loadingStatus: {
            clearSelectedBookingSlotLoading: { $set: true },
          },
        });
      },
    ],
    [
      CLEAR_SELECTED_BOOKING_SLOT_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            clearSelectedBookingSlotLoading: { $set: false },
          },
          selectedBookingSlot: { $set: {} },
        });
      },
    ],
    [
      CLEAR_SELECTED_BOOKING_SLOT_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            clearSelectedBookingSlotLoading: { $set: false },
          },
        });
      },
    ],

    //Booking detail
    [
      LOAD_BOOKING_DETAIL,
      state => {
        return update(state, {
          loadingStatus: {
            bookingDetailLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_BOOKING_DETAIL_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            bookingDetailLoading: { $set: false },
          },
          bookingDetail: { $set: action.payload },
        });
      },
    ],
    [
      LOAD_BOOKING_DETAIL_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            bookingDetailLoading: { $set: false },
          },
        });
      },
    ],
    [
      RESET_BOOKING_DETAIL,
      state => {
        return update(state, {
          loadingStatus: {
            bookingDetailLoading: { $set: true },
          },
          bookingDetail: { $set: {} },
        });
      },
    ],

    //update booking info
    [
      UPDATE_BOOKING_INFO,
      state => {
        return update(state, {
          loadingStatus: {
            bookingDetailLoading: { $set: true },
          },
        });
      },
    ],
    [
      UPDATE_BOOKING_INFO_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            bookingDetailLoading: { $set: false },
          },
          bookingDetail: { $set: action.payload },
        });
      },
    ],
    [
      UPDATE_BOOKING_INFO_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            bookingDetailLoading: { $set: false },
          },
        });
      },
    ],
    [
      RESET_TIME_SLOT_DATA,
      state => {
        return update(state, {
          timeSlotData: {
            $set: {},
          },
        });
      },
    ],
    [
      RESET_CURRENT_HOLDING_SLOT,
      state => {
        return update(state, {
          currentHoldingSlot: {
            $set: {},
          },
        });
      },
    ],
  ]),
  initialState,
);
export default newBookingReducer;
